module.exports = __webpack_public_path__ + "static/img/587_phase_function_Paper_PointsHejduk_Prediction.f704693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/587_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iSCG
// module chunks = 0